import { render, staticRenderFns } from "./ZupanijaDetails.vue?vue&type=template&id=bc29181a&scoped=true&"
import script from "./ZupanijaDetails.vue?vue&type=script&lang=js&"
export * from "./ZupanijaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc29181a",
  null
  
)

export default component.exports